export const apiUrl = process.env.REACT_APP_AWN_API_URL || "https://api.artwownow.com";

export const s3Url = "https://art-wow-now.s3.amazonaws.com";
// live url 0
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const videoThumbnailUrl = (videoId) => {
  return `https://image.mux.com/${videoId}/thumbnail.png`;
};
